<div class="flex-direction-column gap-5">
  @if (label) {
    <div class="flex-direction-row align-center gap-5">
      <span class="label" [style.color]="colorLabel ?? ''" [style.font-size]="fontLabel" [style.font-weight]="fontWeight">{{label}}</span>
      @if (dica) {
        <img [matTooltip]="dica" src="./assets/icones/dica.svg" alt="" />
      }
    </div>
  }

  @if (carregandoInfo) {
    <div
      class="skeleton"
      [style.width]="widthFormField"
      [style.height]="heightFormField">
    </div>
  } @else if (isCheckbox) {
    <mat-checkbox [disabled]="disabled" [(ngModel)]="value" (change)="changeCheckbox()"></mat-checkbox>
  } @else {
    <mat-form-field
      [ngClass]="classe"
      [style.width]="widthFormField"
      [style.height]="heightFormField"
      [style.max-width]="widthFormField"
      [style.max-height]="heightFormField"
      [style.min-width]="widthFormField"
      [style.min-height]="heightFormField"
      [hideRequiredMarker]="true"
      [style.background-color]="backgroundColor ?? 'white'"
      [ngStyle]="isInvalid ? {'border-color': '#f44336'} : {'border-color': borderColor ?? 'transparent'}">

        @if(!isDateRange){
            @if (iconPrefix) {
              <mat-icon class="mat-icon-style" [style.color]="iconColor ?? 'black'" matPrefix>{{iconPrefix}}</mat-icon>
            }

          @if (textPrefix) {
            <span matTextPrefix>{{ textPrefix }}&nbsp;</span>
          }

          <input
            #internalInput
            [style.font-size]="font"
            matInput
            [name]="autocomplete ?? (isSenha ? 'new-password-' + label : type)"
            [autocomplete]="autocomplete ?? (isSenha ? 'new-password' : type)"
            [type]="type"
            [min]="min"
            [max]="max"
            [step]="step"
            [maxlength]="max"
            [mask]="mask"
            [disabled]="disabled"
            [attr.maxlength]="maxLengthFormFiles ? maxLengthFormFiles : null"
            [placeholder]="placeholder"
            [(ngModel)]="value"
            [class.mat-form-field-invalid]="isInvalid"
            (focusout)="focusOut()"
            (ngModelChange)="change()" />

            @if (iconSuffix && !isSenha) {
              <mat-icon [style.color]="iconColor ?? 'black'" matSuffix>{{iconSuffix}}</mat-icon>
            }
            @if (isSenha) {
              <button mat-icon-button [style.color]="iconColor ?? 'black'" (click)="toggleMostrarSenha()" matSuffix>
                <mat-icon>{{iconSuffixSenha}}</mat-icon>
              </button>
            }
        }@else{

        <ng-container>
          <mat-date-range-input [rangePicker]="picker" [disabled]="disabled">
            <input matStartDate
              [(ngModel)]="dataInicio"
              (ngModelChange)="change()"
              (focusout)="focusOut()"
              placeholder="Data Inicial"
              name="dataInicio"
              required>
            <input matEndDate
              [(ngModel)]="dataFim"
              (ngModelChange)="change()"
              (focusout)="focusOut()"
              placeholder="Data Final"
              name="dataFim"
              required>
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </ng-container>

      }
    </mat-form-field>
  }

  @if (showValidationErrors && isInvalid && !carregandoInfo) {
    <div class="error-message">
      {{ getErrorMessage() }}
    </div>
  }
</div>
